(function($) {

    function add_restock_reminder(product_variant_id, customer_email, error_message){

        let url = ghostpress_params.ajax_url + "&action=add_restock_reminder",
            data = {
                "product_variant_id": product_variant_id,
                "customer_email": customer_email
            }

        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
        .done(function(response, textStatus, jqXHR) {
            if(!response.success){
                alert(error_message)
            }
        })
        .fail(function(response, textStatus, jqXHR) {
            alert(error_message)
        })
    }

    function form_submit(e){

        e.preventDefault();

        let product_variant_id = $(this).find("input[name='product_variant_id']").val()
        let customer_email = $(this).find("input[name='customer_email']").val()
        let error_messages = $(this).data("error-messages")

        if(!product_variant_id){
            alert(error_messages["no_product_variant_id"])
            return
        }

        add_restock_reminder(product_variant_id, customer_email ? customer_email : false, error_messages["form_submit_error"])
    }

    // Init again fields from AJAX fragments
    $(document).gp_ready(function(){
        $("#form-restock-reminder").off("submit").on("submit", form_submit);
    })

})(jQuery);
